export const NOTIFICATION_STATE = {
    NONE: 'NONE',
    VIEWED: 'VIEWED',
    CLICKED: 'CLICKED',
    INACTIVE: 'INACTIVE',
};
